import styled from 'styled-components'

export const CitiesWrapper = styled.div`
  .cities-list {
    margin-top: 30px;
  }

  .filter-box {
    &.align-left {
      float: left;
    }

    &.align-right {
      float: right;
    }
  }

  .link-edit-main {
    position: absolute;
    right: 40px;
    top: 60px;
  }

  .button-container {
    display: flex;
    position: absolute;
    right: 110px;
    top: 60px;
    & > * {
      padding-left: 0px;
    }
  }
`



// WEBPACK FOOTER //
// ./src/Components/City/index.js